import { render } from "./PriceView.vue?vue&type=template&id=5f0b5086&scoped=true"
import script from "./PriceView.vue?vue&type=script&lang=js"
export * from "./PriceView.vue?vue&type=script&lang=js"

import "./PriceView.vue?vue&type=style&index=0&id=5f0b5086&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0b5086"]])

export default __exports__